(function() {
  var FrameworkAlign, FrameworkAnimation, FrameworkCart, FrameworkLoadingAnimation, FrameworkMediaQueries, FrameworkModal, FrameworkOffCanvas, FrameworkSearch, FrameworkSlider, FrameworkStickyColumn, LayoutAlign, LayoutFooter, LayoutHeader, PartialFullScreenPanel, PartialMainMenu, PartialProduct,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  FrameworkAlign = (function() {
    function FrameworkAlign(element, type) {
      this.element = element;
      this.type = type;
      this.resizeListeners = __bind(this.resizeListeners, this);
      this.fillYSpace = __bind(this.fillYSpace, this);
      this.checkOverlap = __bind(this.checkOverlap, this);
      this.createOverlapDetectors = __bind(this.createOverlapDetectors, this);
      this.position = __bind(this.position, this);
      this.parent = this.element.parent();
      this.left_side_border;
      this.right_element_width = null;
      this.position();
      this.fillYSpace();
      this.createOverlapDetectors();
      this.resizeListeners();
    }

    FrameworkAlign.prototype.position = function() {
      if (this.type === 'center-x') {
        if (!Modernizr.csstransforms) {
          this.element.css({
            'margin-left': -(this.element.outerWidth() / 2)
          });
        }
      }
      if (this.type === 'center-y') {
        if (!Modernizr.csstransforms) {
          return this.element.css({
            'margin-top': -(this.element.outerHeight() / 2)
          });
        }
      }
    };

    FrameworkAlign.prototype.createOverlapDetectors = function() {
      var _this;
      _this = this;
      if (_this.type === 'right') {
        return this.right_element_width = _this.element.outerWidth();
      }
    };

    FrameworkAlign.prototype.checkOverlap = function() {
      var left_element, left_side_border, right_side_border, _this;
      _this = this;
      if (_this.type === 'right') {
        _this.parent.removeClass('overlap');
        left_element = _this.parent.children().eq(_this.element.index() - 1);
        left_side_border = left_element.position().left + left_element.outerWidth();
        right_side_border = _this.parent.outerWidth() - _this.right_element_width;
        if (left_side_border >= right_side_border) {
          return _this.parent.addClass('overlap');
        }
      }
           
    };

    FrameworkAlign.prototype.fillYSpace = function() {
      var container_height, text_panel_height, _this;
      _this = this;
      if (_this.type === 'fill-y') {
        container_height = _this.parent.height();
        text_panel_height = _this.parent.find('.fw--align--bottom').outerHeight();
        return _this.element.height(container_height - text_panel_height);
      }
    };

    FrameworkAlign.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      $(window).on('resize.FrameworkAlign', function() {
        _this.checkOverlap();
        return _this.fillYSpace();
      });
      return setTimeout(function() {
        return _this.checkOverlap();
      }, 1);
    };

    return FrameworkAlign;

  })();

  FrameworkAnimation = (function() {
    function FrameworkAnimation() {}

    return FrameworkAnimation;

  })();

  FrameworkCart = (function() {
    function FrameworkCart(container, mq) {
      this.container = container;
      this.mq = mq;
      this.convertCurrency = __bind(this.convertCurrency, this);
      this.openModalListener = __bind(this.openModalListener, this);
      this.openOffCanvasListener = __bind(this.openOffCanvasListener, this);
      this.removeItem = __bind(this.removeItem, this);
      this.removeItemListeners = __bind(this.removeItemListeners, this);
      this.updateTotals = __bind(this.updateTotals, this);
      this.plusQuantity = __bind(this.plusQuantity, this);
      this.minusQuantity = __bind(this.minusQuantity, this);
      this.updateQuantityListeners = __bind(this.updateQuantityListeners, this);
      this.addItem = __bind(this.addItem, this);
      this.renderOther = __bind(this.renderOther, this);
      this.renderListener = __bind(this.renderListener, this);
      this.renderCart = __bind(this.renderCart, this);
      this.adjusting_qty_timer = null;
      this.table_content = this.container.find('form > .content');
      this.render_trigger = $('.fw--cart-modal--trigger-render');
      this.totals = {};
      this.add_locked = false;
      this.render_locked = false;
      if (this.container.hasClass('off-canvas')) {
        this.view = 'off canvas';
      }
      if (this.container.hasClass('modal')) {
        this.view = 'modal';
      }
      this.temp_quantity = 0;
      this.renderCart();
      if (this.view === 'off canvas') {
        this.openOffCanvasListener();
      }
      this.openModalListener();
      this.renderListener();
    }

    FrameworkCart.prototype.renderCart = function(callback) {
      var _this;
      _this = this;
      if (!_this.render_locked) {
        _this.render_locked = true;
        _this.table_content.empty();
        return $.ajax({
          type: "POST",
          url: "/cart.js",
          dataType: "json"
        }).done(function(data, textStatus, jqXHR) {
          var cart, index, item, row, _i, _len, _ref;
          if (textStatus === 'success') {
            cart = data;
            if (cart.items.length) {
              _this.container.removeClass('no-items');
            } else {
              _this.container.addClass('no-items');
            }
            _ref = cart.items;
            for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
              item = _ref[index];
              item.image_url = Shopify.resizeImage(item.image, "medium");
              item.price = Currency.formatMoney(item.price, theme.money_format);
              if ((index + 1) === cart.items.length) {
                row = '<div class="variant-id last-variant width--12" data-variant-id=' + item.variant_id + '>';
              } else {
                row = '<div class="variant-id width--12" data-variant-id=' + item.variant_id + '>';
              }
              row += '<div class="width--12 width--medium-4 width--large-6 block">';
              if (item.image_url === null) {
                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"></span>';
              } else {
                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"><a href="' + item.url + '"><img src="' + item.image_url + '" alt="' + item.title + '"></a></span>';
              }
              row += '<span class="title show--small show--large block width--8 spacing--3 font-size--4"><a href="' + item.url + '">' + item.title + '</a></span>';
              row += '</div>';
              row += '<div class="right-column width--12 width--medium-8 width--large-6 block spacing--3y text-align--left text-align--large-right">';
              row += '<span class="title show--medium block width--12 spacing--3 font-size--4"><a href="' + item.url + '">' + item.title + '</a></span>';
              row += '<span class="price font--accent spacing--3 font-size--3 money">' + item.price + '</span>';
              row += '<span class="quantity spacing--3"><div class="input--number"><a class="minus"><span class="glyph--minus"></span></a><input type="text" value="' + item.quantity + '" min="1" pattern="[1-9]*"><a class="plus"><span class="glyph--plus"></span></a></div></span>';
              row += '<span class="remove spacing--3"><a href="#" class="remove glyph--cross-circle"></a></span>';
              row += '</div>';
              row += '</div>';
              row += '<div class="spacer spacing--3y"></div>';
              _this.table_content.append(row);
            }
            row = '<div class="totals width--12 text-align--center ">';
            row += '<div class="width--12 width--large-8 block">';
            row += '</div>';
            row += '<div class="block spacing--3y width--12 width--large-4 font-size--3 text--bold text-align--large-right text--uppercase">';
            row += '<span class="spacing--3">' + theme.translation.cart_subtotal + '</span>';
            row += '<span class="total spacing--3 money font--accent font--subheading--size">' + _this.totals.price + '</span>';
            row += '</div>';
            row += '</div>';
            row += '<div class="spacer spacing--3y show--small-medium"></div>';
            _this.table_content.append(row);
            _this.updateTotals();
            if (callback) {
              callback();
            }
            $(window).trigger('resize.FrameworkModal');
            _this.render_locked = false;
            _this.removeItemListeners();
            _this.updateQuantityListeners();
            return _this.convertCurrency(_this.container.find('.money'));
          } else {
            return console.log('cart - render item status - ' + textStatus);
          }
        }).fail(function(jqXHR, textStatus) {
          console.log("cart rendering failed");
          return _this.render_locked = false;
        });
      }
    };

    FrameworkCart.prototype.renderListener = function() {
      var _this;
      _this = this;
      return this.container.on('renderCart', function() {
        return _this.renderCart();
      });
    };

    FrameworkCart.prototype.renderOther = function() {
      if (this.mq.current_window === 'small') {
        return $('.fw--cart.modal').trigger('renderCart');
      } else {
        return $('.fw--cart.off-canvas').trigger('renderCart');
      }
    };

    FrameworkCart.prototype.addItem = function(form, callback) {
      var _this;
      _this = this;
      if (!_this.add_locked) {
        _this.add_locked = true;
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: form.serialize()
        }).done(function(data, textStatus, jqXHR) {
          callback(true);
          _this.renderOther();
          return _this.add_locked = false;
        }).fail(function(jqXHR, textStatus) {
          callback(false, jqXHR.responseJSON.description);
          return _this.add_locked = false;
        });
      }
    };

    FrameworkCart.prototype.updateQuantityListeners = function() {
      var _this;
      _this = this;
      this.table_content.find('.input--number input').attr("autocomplete", "off").on('keyup.LayoutCartModal paste.LayoutCartModal', function() {
        var input, input_wrapper, variant_id;
        input_wrapper = $(this).closest('.input--number');
        input = input_wrapper.find('input');
        if (parseInt(input.val()) > 0) {
          input_wrapper.addClass('updating');
          clearTimeout(_this.adjusting_qty_timer);
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.adjusting_qty_timer = setTimeout(function() {
            _this.updateCart(variant_id, parseInt(input.val()));
            input_wrapper.removeClass('updating');
            return _this.updateTotals();
          }, 500);
        } else if (parseInt(input.val()) === 0) {
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.removeItem(variant_id);
          if ($(this).closest('form').find('.variant-id').length === 1) {
            _this.container.addClass('no-items');
          } else {
            $(this).closest('.variant-id').remove();
          }
        }
        return false;
      });
      this.table_content.find('.input--number .minus').on('click.LayoutCartModal', function() {
        var input, input_wrapper, variant_id;
        input_wrapper = $(this).closest('.input--number');
        input = input_wrapper.find('input');
        if (parseInt(input.val()) > 1) {
          input_wrapper.addClass('updating');
          clearTimeout(_this.adjusting_qty_timer);
          input.val(parseInt(input.val()) - 1);
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.adjusting_qty_timer = setTimeout(function() {
            _this.minusQuantity(variant_id, parseInt(input.val()));
            input_wrapper.removeClass('updating');
            return _this.updateTotals();
          }, 500);
        }
        return false;
      });
      return this.table_content.find('.input--number .plus').on('click.LayoutCartModal', function() {
        var input, input_wrapper, variant_id;
        clearTimeout(_this.adjusting_qty_timer);
        input_wrapper = $(this).closest('.input--number');
        input = input_wrapper.find('input');
        if (_this.temp_quantity === 0) {
          _this.temp_quantity = parseInt(input.val());
        }
        input_wrapper.addClass('updating');
        input.val(1 + parseInt(input.val()));
        variant_id = $(this).closest('.variant-id').data('variant-id');
        _this.adjusting_qty_timer = setTimeout(function() {
          var add_quantity;
          add_quantity = parseInt(input.val()) - _this.temp_quantity;
          return _this.plusQuantity(variant_id, add_quantity, function(pass, error) {
            if (pass) {
              input_wrapper.removeClass('updating');
              _this.updateTotals();
              return _this.temp_quantity = 0;
            } else {
              input.val(_this.temp_quantity);
              input_wrapper.removeClass('updating');
              _this.updateTotals();
              return _this.temp_quantity = 0;
            }
          });
        }, 500);
        return false;
      });
    };

    FrameworkCart.prototype.minusQuantity = function(variant_id, quantity) {
      var _this;
      _this = this;
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: 'quantity=' + quantity + '&id=' + variant_id,
        async: false
      }).done(function(data, textStatus, jqXHR) {
        if (textStatus === 'success') {
          _this.updateTotals();
          return _this.renderOther();
        } else {
          return console.log('cart - update cart item status - ' + textStatus);
        }
      }).fail(function(jqXHR, textStatus) {
        return console.log("cart - update failed");
      });
    };

    FrameworkCart.prototype.plusQuantity = function(variant_id, quantity, callback) {
      var _this;
      _this = this;
      if (!_this.add_locked) {
        _this.add_locked = true;
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: 'quantity=' + quantity + '&id=' + variant_id
        }).done(function(data, textStatus, jqXHR) {
          callback(true);
          _this.renderOther();
          return _this.add_locked = false;
        }).fail(function(jqXHR, textStatus) {
          callback(false, jqXHR.responseJSON.description);
          return _this.add_locked = false;
        });
      }
    };

    FrameworkCart.prototype.updateTotals = function() {
      var _this;
      _this = this;
      return $.ajax({
        type: "POST",
        url: "/cart.js",
        dataType: "json"
      }).done(function(data, textStatus, jqXHR) {
        var cart, cart_total, item, _i, _len, _ref;
        if (textStatus === 'success') {
          cart = data;
          cart_total = {};
          cart_total.quantity = 0;
          cart_total.price = 0;
          _ref = cart.items;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            item = _ref[_i];
            cart_total.quantity += item.quantity;
            cart_total.price += item.price * item.quantity;
          }
          _this.totals.count = cart_total.quantity;
          _this.totals.price = Currency.formatMoney(cart_total.price, theme.money_format);
          _this.render_trigger.find('.count').html(_this.totals.count);
          _this.render_trigger.find('.total-price').html(_this.totals.price);
          _this.table_content.find('.total').html(_this.totals.price);
          $('.layout--header .layout--off-canvas--trigger.right').html(_this.totals.count);
          $('.layout--header .cart-link .count').html('(' + _this.totals.count + ')');
          if (_this.totals.count > 0) {
            _this.render_trigger.css('display', 'inline-block');
            $('.layout--header .cart-link .count').css('display', 'inline');
            $('.layout--header .cart-count').css('display', 'inline-block');
          } else {
            _this.render_trigger.hide();
            $('.layout--header .cart-link .count').hide();
          }
          if (theme.currency_switcher_enabled) {
            _this.convertCurrency(_this.render_trigger.find('.total-price'));
            return _this.convertCurrency(_this.table_content.find('.total'));
          }
        } else {
          return console.log('cart - update totals item status - ' + textStatus);
        }
      }).fail(function(jqXHR, textStatus) {
        return console.log("cart - updating totals failed");
      });
    };

    FrameworkCart.prototype.removeItemListeners = function() {
      var _this;
      _this = this;
      return this.table_content.find('a.remove').on('click.LayoutCartModal', function() {
        var variant_id;
        variant_id = $(this).closest('.variant-id').data('variant-id');
        _this.removeItem(variant_id);
        if ($(this).closest('form').find('.variant-id').length === 1) {
          _this.container.addClass('no-items');
          $(window).trigger('resize.FrameworkModal');
        } else {
          $(this).closest('.variant-id').remove();
        }
        _this.updateTotals();
        return false;
      });
    };

    FrameworkCart.prototype.removeItem = function(variant_id) {
      return this.minusQuantity(variant_id, 0);
    };

    FrameworkCart.prototype.openOffCanvasListener = function() {
      return $('.layout--off-canvas--cart--open-trigger').on('click', function() {
        $('.layout--off-canvas--sidebar.right').trigger('open');
        return false;
      });
    };

    FrameworkCart.prototype.openModalListener = function() {
      return $('.fw--cart-modal--trigger-render').on('click', function() {
        $('.fw--modal.cart-link .modal-link').trigger('click');
        return false;
      });
    };

    FrameworkCart.prototype.convertCurrency = function(elems) {
      if (theme.currency_switcher_enabled) {
        return Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, elems, null, true);
      } else {
        return false;
      }
    };

    return FrameworkCart;

  })();

  FrameworkLoadingAnimation = (function() {
    function FrameworkLoadingAnimation(container) {
      this.container = container;
      this.loading_animation = $('.fw--loading_animation');
      if (this.loading_animation.hasClass('tiny')) {
        this.loading_animation.spin('tiny');
      } else {
        this.loading_animation.spin('small');
      }
    }

    return FrameworkLoadingAnimation;

  })();

  FrameworkMediaQueries = (function() {
    function FrameworkMediaQueries() {
      this.screenSizeListener = __bind(this.screenSizeListener, this);
      this.getScreenSize = __bind(this.getScreenSize, this);
      this.medium_screen = 768;
      this.large_screen = 1024;
      this.current_window = null;
      this.getScreenSize();
      this.screenSizeListener();
    }

    FrameworkMediaQueries.prototype.getScreenSize = function() {
      var _this;
      _this = this;
      if ($("html").hasClass("lt-ie9")) {
        $.event.trigger("largeWindow");
        return _this.current_window = 'large';
      } else if (window.matchMedia('only screen and (min-width: ' + _this.large_screen + 'px)').matches) {
        if (_this.current_window !== 'large') {
          $.event.trigger("largeWindow");
          return _this.current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + _this.medium_screen + 'px)').matches) {
        if (_this.current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return _this.current_window = 'medium';
        }
      } else {
        if (_this.current_window !== 'small') {
          $.event.trigger("smallWindow");
          return _this.current_window = 'small';
        }
      }
    };

    FrameworkMediaQueries.prototype.screenSizeListener = function() {
      var _this;
      _this = this;
      return $(window).resize(function() {
        return _this.getScreenSize();
      });
    };

    return FrameworkMediaQueries;

  })();

  FrameworkModal = (function() {
    function FrameworkModal(container) {
      this.container = container;
      this.fullwidth = this.container.data('fullwidth') ? true : false;
      this.links = this.container.find('.modal-link');      
      this.content = this.container.find('.modal');
      this.spinner = null;
      this.window = this.createModalWindow();
      this.spinner = this.window.find('.fw--loading_animation');
      this.spinner.spin('large', '#fff');
      this.window_container = this.window.find('> .container');
      this.mask = this.window.find('> .modal-mask');
      this.close_button = this.window.find('> .close');
      this.next_button = this.window.find('> .modal-next');
      this.prev_button = this.window.find('> .modal-prev');
      this.slider = null;
      this.slides = null;
      this.main_content_window = $('.fw--off-canvas--main-content');
      this.openListeners();
      this.nav_lock = false;
    }
    
   
    FrameworkModal.prototype.createModalWindow = function() {
      var window, window_html, _this;
      _this = this;
      window = null;
      if ($('.fw--modal.window').length) {
        window = $('.fw--modal.window');
      } else {
        window_html = '<div class="fw--modal window"> <div class="modal-mask"></div> <div class="fw--loading_animation"></div> <div class="container"></div> <a aria-hidden="true" class="close glyph--cross"></a> <a aria-hidden="true" class="modal-prev glyph--chevron-left"></a> <a aria-hidden="true" class="modal-next glyph--chevron-right"></a> </div>';
        window = $(window_html).appendTo('body');
      }
      if (this.fullwidth) {
        window.addClass('fullwidth');
      } else {
        window.removeClass('fullwidth');
      }
      return window;
    };

    FrameworkModal.prototype.openListeners = function() {
      var _this;
      _this = this;
      return this.links.on('click.FrameworkModal', function() {
        var index;
        index = _this.links.index(this);
        _this.open(index);
        return false;
      });
    };

    FrameworkModal.prototype.open = function(index) {
      var scrolled_position, _this;
      _this = this;
      this.closeListeners();
      this.positionListeners();
      scrolled_position = $(window).scrollTop();
      this.main_content_window.css({
        position: 'fixed',
        top: -scrolled_position
      });
      this.moveContentToWindow();
      if (this.slides.length > 1) {
        this.next_button.show();
        this.prev_button.show();
        this.prevListeners();
        this.nextListeners();
      }
      if (this.fullwidth) {
        this.window_container.addClass('fullwidth');
      }
      _this.window.show();
      _this.mask.fadeIn();
      _this.window_container.show();
      _this.renderVideo(_this.slides.eq(index));
      return _this.loadModal(this.slides.eq(index), function() {
        return setTimeout(function() {
          return _this.window_container.find('input[type="text"]').focus();
        }, 0);
      });
    };

    FrameworkModal.prototype.moveContentToWindow = function(index) {
      var content, _this;
      _this = this;
      content = this.container.find('.modal');
      this.window_container.append(content);
      return this.slides = this.window_container.find('> .modal');
    };

    FrameworkModal.prototype.detectImageSlide = function(slide) {
      var _this;
      _this = this;
      if (slide.children().length === 1 && slide.children().first().is('img')) {
        slide.addClass('type--image');
        return slide.find('img').css({
          'max-height': $(window).height()
        });
      }
    };

    FrameworkModal.prototype.renderVideo = function(slide) {
      var id, iframe, src_url, type, video, _this;
      _this = this;
      video = slide.find('.responsive-video').first();
      src_url = video.data('video');
      type = _this.extractVideoType(src_url);
      id = _this.extractVideoId(src_url, type);
      iframe = _this.createIframe(type, id);
      if (type === 'vimeo') {
        video.addClass('vimeo');
      }
      return video.append(iframe);
    };

    FrameworkModal.prototype.extractVideoType = function(src_url) {
      var matches, re;
      re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(src_url);
      if (matches) {
        return 'youtube';
      } else {
        re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        matches = re.exec(src_url);
        if (matches) {
          return 'vimeo';
        }
      }
      return false;
    };

    FrameworkModal.prototype.extractVideoId = function(src_url, type) {
      var match, regExp;
      if (type === 'youtube') {
        regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = src_url.match(regExp);
        if (match) {
          return match[2];
        }
      }
    };

    FrameworkModal.prototype.createIframe = function(type, id) {
      if (type === "youtube") {
        return '<iframe  src="//www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allowfullwidth></iframe>';
      } else if (type === "vimeo") {
        return '<iframe src="//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>';
      }
    };

    FrameworkModal.prototype.removeVideos = function() {
      return this.slides.find('.responsive-video').each(function() {
        if ($(this).data('video')) {
          return $(this).find('iframe').remove();
        }
      });
    };

    FrameworkModal.prototype.loadModal = function(modal, callback) {
      var _this;
      _this = this;
      _this.spinner.show();
      return setTimeout(function() {
        return modal.imagesLoaded(function() {
          _this.spinner.hide();
          modal.addClass('active');
          _this.position();
          if (callback) {
            callback();
          }
          return _this.nav_lock = false;
        });
      }, 300);
    };

    FrameworkModal.prototype.position = function() {
      var active_modal, entire_modal_height, modal_height, modal_width, _this;
      _this = this;
      if (this.window_container != null) {
        active_modal = this.content.filter('.active');
        _this.window_container.attr('style', '');
        _this.positionVideoColumns(active_modal);
        _this.detectImageSlide(active_modal);
        modal_height = active_modal.outerHeight();
        modal_width = active_modal.outerWidth();
        entire_modal_height = modal_height + parseInt(_this.window.css('padding-top')) + parseInt(_this.window.css('padding-bottom'));
        if (active_modal.hasClass('type--image')) {
          entire_modal_height = modal_height;
        }
        if ($(window).height() >= entire_modal_height) {
          return _this.window.addClass('fixed');
        } else {
          $("html, body").animate({
            scrollTop: 0
          }, '0');
          $('body,html').on('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal', function(e) {
            if (e.which > 0 || e.type === "mousewheel" || e.type === "touchmove") {
              return $("html,body").stop();
            }
          });
          return _this.window.removeClass('fixed');
        }
      }
    };

    FrameworkModal.prototype.positionVideoColumns = function(modal) {
      var column_one, column_two, height_one, height_two;
      if (modal.find('.responsive-video').length > 0) {
        column_one = modal.find('.fw--blocks > div').eq(0);
        column_two = modal.find('.fw--blocks > div').eq(1);
        column_one.css({
          width: ''
        });
        column_two.css({
          width: ''
        });
        height_one = column_one.outerHeight();
        height_two = column_two.outerHeight();
        if (height_one < height_two) {
          column_one.css({
            width: '100%'
          });
          return column_two.css({
            width: '100%'
          });
        }
      }
    };

    FrameworkModal.prototype.positionListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FrameworkModal', function() {
        return _this.position();
      });
    };

    FrameworkModal.prototype.nextListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 39) {
          return _this.next();
        }
      });
      return this.next_button.on('click.FrameworkModal', function() {
        return _this.next();
      });
    };

    FrameworkModal.prototype.next = function() {
      var active_slide, index;
      if (!this.nav_lock) {
        this.nav_lock = true;
        index = this.slides.filter('.active').index();
        this.slides.removeClass('active');
        this.removeVideos();
        if ((index + 1) === this.slides.length) {
          active_slide = this.slides.eq(0);
        } else {
          active_slide = this.slides.eq(index + 1);
        }
        this.renderVideo(active_slide);
        return this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.prevListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 37) {
          return _this.prev();
        }
      });
      return this.prev_button.on('click.FrameworkModal', function() {
        return _this.prev();
      });
    };

    FrameworkModal.prototype.prev = function() {
      var active_slide, index;
      if (!this.nav_lock) {
        this.nav_lock = true;
        index = this.slides.filter('.active').index();
        this.slides.removeClass('active');
        this.removeVideos();
        if (index === 0) {
          active_slide = this.slides.eq(this.slides.length - 1);
        } else {
          active_slide = this.slides.eq(index - 1);
        }
        this.renderVideo(active_slide);
        return this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.closeListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 27) {
          return _this.close();
        }
      });
      this.mask.on('click.FrameworkModal', function() {
        return _this.close();
      });
      this.window_container.on('click.FrameworkModal', function() {
        return _this.close();
      });
      this.content.on('click.FrameworkModal', function(e) {
        return e.stopPropagation();
      });
      return this.close_button.on('click.FrameworkModal', function() {
        return _this.close();
      });
    };

    FrameworkModal.prototype.close = function() {
      var scrolled_position, _this;
      _this = this;
      scrolled_position = parseInt(this.main_content_window.css('top')) * -1;
      this.container.trigger('modalClosed');
      this.main_content_window.css({
        top: '0',
        position: 'relative'
      });
      $(window).scrollTop(scrolled_position);
      this.putBackContent();
      this.next_button.hide();
      this.prev_button.hide();
      this.window.hide();
      this.mask.fadeOut(function() {
        return _this.window_container.empty();
      });
      return this.removeListeners();
    };

    FrameworkModal.prototype.putBackContent = function() {
      this.removeVideos();
      return this.slides.removeClass('active').appendTo(this.container);
    };

    FrameworkModal.prototype.removeListeners = function() {
      $(document).off('keydown.FrameworkModal');
      $(window).off('resize.FrameworkModal');
      $('body,html').off('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal');
      this.next_button.off('click.FrameworkModal');
      this.prev_button.off('click.FrameworkModal');
      this.close_button.off('click.FrameworkModal');
      this.mask.off('click.FrameworkModal');
      return this.window_container.off('click.FrameworkModal');
    };

    return FrameworkModal;

  })();

  FrameworkOffCanvas = (function() {
    function FrameworkOffCanvas() {
      this.closeRight = __bind(this.closeRight, this);
      this.closeLeft = __bind(this.closeLeft, this);
      this.closeListeners = __bind(this.closeListeners, this);
      this.fadeInOverlay = __bind(this.fadeInOverlay, this);
      this.openRight = __bind(this.openRight, this);
      this.openLeft = __bind(this.openLeft, this);
      this.openListeners = __bind(this.openListeners, this);
      this.viewPortHeightListener = __bind(this.viewPortHeightListener, this);
      this.setViewPortHeight = __bind(this.setViewPortHeight, this);
      this.toggleListeners = __bind(this.toggleListeners, this);
      this.viewport = $('.fw--off-canvas--viewport');
      this.left_sidebar = $('.fw--off-canvas--sidebar.left');
      this.right_sidebar = $('.fw--off-canvas--sidebar.right');
      this.main_content = $('.fw--off-canvas--main-content');
      this.overlay = this.main_content.find('> .overlay');
      this.triggers = $('.fw--off-canvas--trigger');
      this.state = 'closed';
      this.setViewPortHeight();
      this.viewPortHeightListener();
      this.openListeners();
      this.closeListeners();
    }

    FrameworkOffCanvas.prototype.toggleListeners = function() {
      var _this;
      _this = this;
      return this.sub_menu_links.on('click.LayoutMainMenu', function() {
        if (_this.state === 'closed') {
          _this.open($(this));
        } else if ($(this).hasClass('open')) {
          _this.close($(this));
        } else {
          _this.changeTo($(this));
        }
        return false;
      });
    };

    FrameworkOffCanvas.prototype.setViewPortHeight = function() {
      var _this;
      _this = this;
      return _this.viewport.css({
        'min-height': $(window).height()
      });
    };

    FrameworkOffCanvas.prototype.viewPortHeightListener = function() {
      var _this;
      _this = this;
      return $(window).resize(function() {
        return _this.setViewPortHeight();
      });
    };

    FrameworkOffCanvas.prototype.openListeners = function() {
      var _this;
      _this = this;
      this.triggers.on('click', function() {
        if ($(this).hasClass('open left')) {
          return _this.openLeft();
        } else if ($(this).hasClass('open right')) {
          return _this.openRight();
        }
      });
      return this.right_sidebar.on('open', function() {
        return _this.openRight();
      });
    };

    FrameworkOffCanvas.prototype.openLeft = function() {
      var _this;
      _this = this;
      this.state = 'left-open';
      _this.main_content.css({
        position: 'fixed',
        top: -($(window).scrollTop())
      });
      this.left_sidebar.velocity({
        translateX: [0, '-100%']
      }, {
        complete: function() {
          return _this.left_sidebar.css({
            position: 'relative',
            height: $(window).height()
          });
        }
      });
      this.main_content.velocity({
        translateX: ['90%', 0]
      });
      return this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.openRight = function() {
      var _this;
      _this = this;
      this.state = 'right-open';
      _this.main_content.css({
        position: 'fixed',
        top: -($(window).scrollTop())
      });
      this.right_sidebar.velocity({
        translateX: [0, '100%']
      }, {
        complete: function() {
          return _this.right_sidebar.css({
            position: 'relative',
            left: '10%'
          });
        }
      });
      this.main_content.velocity({
        translateX: ['-90%', 0]
      });
      return this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.fadeInOverlay = function() {
      this.overlay.show();
      return this.overlay.velocity({
        opacity: '0.5'
      });
    };

    FrameworkOffCanvas.prototype.closeListeners = function() {
      var _this;
      _this = this;
      return this.overlay.on('click', function() {
        if (_this.state === 'left-open') {
          return _this.closeLeft();
        } else if (_this.state === 'right-open') {
          return _this.closeRight();
        }
      });
    };

    FrameworkOffCanvas.prototype.closeLeft = function() {
      var scrolled_position, _this;
      _this = this;
      this.state = 'closed';
      scrolled_position = parseInt(this.main_content.css('top')) * -1;
      this.left_sidebar.css({
        position: 'absolute'
      });
      this.main_content.css({
        position: 'relative',
        top: 'initial'
      });
      $(window).scrollTop(scrolled_position);
      this.left_sidebar.velocity({
        translateX: ['-100%', 0]
      });
      this.main_content.velocity({
        translateX: [0, '90%']
      });
      return this.overlay.velocity('fadeOut');
    };

    FrameworkOffCanvas.prototype.closeRight = function() {
      var scrolled_position, _this;
      _this = this;
      this.state = 'closed';
      scrolled_position = parseInt(this.main_content.css('top')) * -1;
      this.right_sidebar.css({
        position: 'absolute',
        left: 'auto'
      });
      this.main_content.css({
        position: 'relative',
        top: 'initial'
      });
      $(window).scrollTop(scrolled_position);
      this.right_sidebar.velocity({
        translateX: ['100%', 0]
      });
      this.main_content.velocity({
        translateX: [0, '-90%']
      });
      return this.overlay.velocity('fadeOut');
    };

    return FrameworkOffCanvas;

  })();

  FrameworkSearch = (function() {
    function FrameworkSearch(container) {
      this.container = container;
      this.linkRows = __bind(this.linkRows, this);
      this.closeListeners = __bind(this.closeListeners, this);
      this.hideResults = __bind(this.hideResults, this);
      this.focusListener = __bind(this.focusListener, this);
      this.getResults = __bind(this.getResults, this);
      this.focusModalAlways = __bind(this.focusModalAlways, this);
      this.listenForKeyEntered = __bind(this.listenForKeyEntered, this);
      this.loadSpinners = __bind(this.loadSpinners, this);
      this.toggle_link = this.container.find('a.toggle');
      this.form = this.container.find('form');
      this.text_box = this.form.find('input[name="q"]');
      this.loading = this.container.find('> .feedback .loading');
      this.no_results = this.container.find('> .feedback .no-results');
      this.results = this.container.find('> .results');
      this.view = this.container.data('view');
      this.max_results = 6;
      this.ajax_request = null;
      this.search_term = null;
      this.search_url = null;
      this.close_results_timer = null;
      this.typing_timer = null;
      this.focusModalAlways();
      this.listenForKeyEntered();
      this.loadSpinners();
    }

    FrameworkSearch.prototype.loadSpinners = function() {
      var spinner;
      spinner = this.loading.find('> .animation');
      if (spinner.hasClass('tiny')) {
        return spinner.spin('tiny');
      } else {
        return spinner.spin('small');
      }
    };

    FrameworkSearch.prototype.listenForKeyEntered = function() {
      var _this;
      _this = this;
      return this.text_box.attr("autocomplete", "off").on("keyup paste", function() {
        var term;
        clearTimeout(_this.typing_timer);
        term = $(this).val();
        _this.results.hide();
        _this.loading.show();
        _this.no_results.hide();
        return _this.typing_timer = setTimeout(function() {
          _this.search_url = "/search?type=product&q=" + term;
          if (term.length > 1) {
            return _this.getResults(term);
          } else {
            _this.results.empty();
            _this.hideResults();
            return _this.loading.hide();
          }
        }, 300);
      });
    };

    FrameworkSearch.prototype.focusModalAlways = function() {
      var _this;
      _this = this;
      if (this.view === 'grid') {
        return this.container.on('click', function() {
          return _this.text_box.focus();
        });
      }
    };

    FrameworkSearch.prototype.getResults = function(term) {
      var _this;
      _this = this;
      if (this.ajax_request) {
        this.ajax_request.abort();
      }
      this.results.empty();
      this.ajax_request = $.getJSON(this.search_url + "&view=json", function(data) {
        if (data.results_count === 0) {
          _this.close_results_timer = setTimeout(function() {
            _this.hideResults();
            _this.no_results.show();
            return _this.loading.hide();
          }, 300);
        } else {
          clearTimeout(_this.close_results_timer);
          _this.loading.hide();
          _this.no_results.hide();
          _this.results.show();
          _this.results.stop(true, true).fadeIn(0);
          $.each(data.results, function(index, item) {
            var row;
            if (index >= _this.max_results) {
              return;
            }
            if (_this.view === 'grid') {
              row = "<div class=\"partial--product item column width--medium-4 width--large-3\" data-link=\"" + item.url + "\">";
              row += '<a href="' + item.url + '">';
              row += '<div class="image-wrapper"><img src="' + item.image_medium + '" /></div>';
              row += '<div class="caption"><p class="title">' + item.title + '</p></div>';
              row += '</a></div>';
              row = $(row);
            } else if (_this.view === 'list') {
              row = $('<a class="item" href="' + item.url + '"><span class="image-wrapper"><img src="' + item.image_thumb + '" /></span><span class="title">' + item.title + '</span></a>');
            }
            _this.results.append(row);
          });
          $.event.trigger("ie8ClearingFix");
          if (data.results_count > _this.max_results) {
            _this.results.append('<div class="row view-more"><a href="' + _this.search_url + '">' + theme.translation.general_search_see_all_results + ' ("' + data.results_count + '")</a></div>');
          }
          _this.closeListeners();
        }
      }).fail(function() {
        return console.log("error retrieving search.json results");
      });
    };

    FrameworkSearch.prototype.focusListener = function() {
      var _this;
      _this = this;
      return this.text_box.on('focus', function() {
        return _this.results.show();
      });
    };

    FrameworkSearch.prototype.hideResults = function() {
      this.results.fadeOut(0);
      return this.focusListener();
    };

    FrameworkSearch.prototype.closeListeners = function() {
      var _this;
      _this = this;
      if (this.view !== "grid") {
        this.linkRows();
        $(document).on('click', function(event) {
          if (!$(event.target).closest('.partial--searchbar').length) {
            return _this.hideResults();
          }
        });
        return $(document).keydown(function(e) {
          if (e.keyCode === 27) {
            return _this.text_box.trigger('blur');
          }
        });
      }
    };

    FrameworkSearch.prototype.linkRows = function() {
      var _this;
      _this = this;
      return this.results.find("td").on('click', function() {
        var link;
        link = $(this).parent().attr('data-link');
        if (link.length) {
          return window.location = link;
        }
      });
    };

    return FrameworkSearch;

  })();

  FrameworkSlider = (function() {
    function FrameworkSlider(container) {
      this.container = container;
      this.eventListeners = __bind(this.eventListeners, this);
      this.alignPlayButton = __bind(this.alignPlayButton, this);
      this.updateContextMenu = __bind(this.updateContextMenu, this);
      this.autoplay = __bind(this.autoplay, this);
      this.formatPaginationNumbers = __bind(this.formatPaginationNumbers, this);
      this.getActiveIndex = __bind(this.getActiveIndex, this);
      this.createSlider = __bind(this.createSlider, this);
      this.autoplay_enabled = this.container.data('autoplay') ? true : false;
      this.navigation = this.container.data('navigation') ? true : false;
      this.pagination_numbers = this.container.data('pagination-numbers') ? true : false;
      this.autoplay_frequency = 3000;
      this.slide_length = this.container.find('.slide').length;
      this.active_index = 0;
      this.news_panel = this.container.data('news-panel') ? true : false;
      this.createSlider();
      this.eventListeners();
      this.owl = this.container.data('owlCarousel');
    }

    FrameworkSlider.prototype.createSlider = function() {
      var slider, _this;
      _this = this;
      slider = this.container.owlCarousel({
        singleItem: true,
        navigation: _this.navigation,
        navigationText: false,
        pagination: _this.container.data('pagination') ? true : false,
        paginationNumbers: _this.pagination_numbers,
        scrollPerPageNav: true,
        slideSpeed: 800,
        autoHeight: false,
        autoPlay: _this.autoplay(),
        afterInit: function() {},
        afterAction: function() {
          _this.alignPlayButton();
          _this.active_index = _this.getActiveIndex();
          _this.updateContextMenu(_this.active_index);
          return _this.formatPaginationNumbers();
        }
      });
      if (_this.navigation) {
        slider.find('.owl-prev').addClass('glyph--chevron-left');
        slider.find('.owl-next').addClass('glyph--chevron-right');
      }
      return slider;
    };

    FrameworkSlider.prototype.getActiveIndex = function() {
      return this.container.find('.owl-pagination .owl-page.active').index();
    };

    FrameworkSlider.prototype.formatPaginationNumbers = function() {
      return this.container.find('.owl-page.active .owl-numbers').text((this.active_index + 1) + "/" + this.slide_length);
    };

    FrameworkSlider.prototype.autoplay = function() {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FrameworkSlider.prototype.updateContextMenu = function(index) {
      var context_navigation, type_class;
      if (this.news_panel) {
        type_class = '.' + this.container.find('.slide').eq(index).data('feed-type');
        context_navigation = this.container.closest('.template--index--news').find('.context-navigation');
        context_navigation.find('.item').hide();
        return context_navigation.find(type_class).show();
      }
    };

    FrameworkSlider.prototype.alignPlayButton = function() {
      var play_button, slide;
      slide = this.container.find('.owl-item').eq(this.active_index);
      play_button = slide.find('.play-button');
      if (play_button.length === 0) {
        return;
      }
      play_button.css('visibility', 'hidden');
      if (PAGE.hasClass('transparent-menu') && $('.main-header').css('position') === 'absolute') {
        slide.find('img').first().imagesLoaded(function() {
          var play_button_height, slide_height, video_offset;
          slide_height = slide.outerHeight();
          play_button_height = play_button.outerHeight();
          video_offset = (slide_height - play_button_height) / 2;
          return play_button.css({
            'margin-top': 0,
            'top': video_offset
          });
        });
      } else {
        play_button.css({
          'margin-top': '-40px',
          'top': '50%'
        });
      }
      return play_button.css('visibility', 'visible');
    };

    FrameworkSlider.prototype.eventListeners = function() {
      var _this;
      _this = this;
      this.container.find(".play-button").on('click', function() {
        var video_modal;
        video_modal = new VideoModal($(this).closest('.video'));
        video_modal.open();
        _this.owl.stop();
        return false;
      });
      return this.container.find('.owl-pagination .owl-page, .skip-to-next').on('click', function() {
        _this.owl.next();
        return false;
      });
    };

    return FrameworkSlider;

  })();

  FrameworkStickyColumn = (function() {
    function FrameworkStickyColumn(container, column_a, column_b, mq) {
      this.container = container;
      this.column_a = column_a;
      this.column_b = column_b;
      this.mq = mq;
      this.Listeners = __bind(this.Listeners, this);
      this.setColumnPosition = __bind(this.setColumnPosition, this);
      this.getAlignment = __bind(this.getAlignment, this);
      this.getState = __bind(this.getState, this);
      this.resetLargerColumn = __bind(this.resetLargerColumn, this);
      this.getSmallerColumn = __bind(this.getSmallerColumn, this);
      this.heightsHaveChanged = __bind(this.heightsHaveChanged, this);
      this.setHeights = __bind(this.setHeights, this);
      this.loadColumns = __bind(this.loadColumns, this);
      if (Modernizr.touch) {
        return false;
      }
      this.container.offset().top;
      this.current_state = 'auto';
      this.column_a_height = 0;
      this.column_b_height = 0;
      this.loadColumns();
    }

    FrameworkStickyColumn.prototype.loadColumns = function() {
      var _this;
      _this = this;
      return _this.container.imagesLoaded(function() {
        _this.Listeners();
        return _this.setColumnPosition();
      });
    };

    FrameworkStickyColumn.prototype.setHeights = function() {
      this.column_a_height = this.column_a.outerHeight();
      return this.column_b_height = this.column_b.outerHeight();
    };

    FrameworkStickyColumn.prototype.heightsHaveChanged = function() {
      if (this.column_a.outerHeight() !== this.column_a_height) {
        this.setHeights();
        return true;
      }
      if (this.column_b.outerHeight() !== this.column_b_height) {
        this.setHeights();
        return true;
      }
      return false;
    };

    FrameworkStickyColumn.prototype.getSmallerColumn = function() {
      if (this.column_a_height < this.column_b_height) {
        return this.column_a;
      } else {
        return this.column_b;
      }
    };

    FrameworkStickyColumn.prototype.resetLargerColumn = function() {
      if (this.column_a_height > this.column_b_height) {
        return this.column_a.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      } else {
        return this.column_b.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      }
    };

    FrameworkStickyColumn.prototype.getState = function(scroll_pos, window_height, column) {
      var column_height, height_for_bottom, overflowing_column, state;
      state = 'auto';
      if (this.mq.current_window === 'small') {
        return 'auto';
      }
      column_height = column.outerHeight();
      if (window_height > column_height) {
        overflowing_column = true;
      }
      if (scroll_pos < this.container.offset().top) {
        state = 'auto';
      }
      if (overflowing_column) {
        height_for_bottom = column_height;
      } else {
        height_for_bottom = window_height;
      }
      if ((scroll_pos + height_for_bottom) > (this.container.offset().top + this.container.outerHeight())) {
        state = 'absolute-bottom';
      } else if (scroll_pos > this.container.offset().top && overflowing_column) {
        state = 'fixed-top';
      } else if (window_height < column_height && (scroll_pos + window_height) > (this.container.offset().top + column.outerHeight())) {
        state = 'fixed-bottom';
      }
      return state;
    };

    FrameworkStickyColumn.prototype.getAlignment = function(column) {
      if (column.hasClass('column-a')) {
        return 'left';
      } else if (column.hasClass('column-b')) {
        return 'right';
      }
    };

    FrameworkStickyColumn.prototype.setColumnPosition = function() {
      var align, column, state, _this;
      _this = this;
      _this.setHeights();
      column = _this.getSmallerColumn();
      state = _this.getState($(window).scrollTop(), $(window).height(), column);
      align = _this.getAlignment(column);
      if (state === 'auto' && this.current_state !== 'auto') {
        this.current_state = 'auto';
        column.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      } else if (state === 'fixed-bottom' && this.current_state !== 'fixed-bottom') {
        this.current_state = 'fixed-bottom';
        column.css({
          'position': 'fixed',
          'top': 'auto',
          'bottom': 0
        });
      } else if (state === 'fixed-top' && this.current_state !== 'fixed-top') {
        this.current_state = 'fixed-top';
        column.css({
          'position': 'fixed',
          'top': 0,
          'bottom': 'auto'
        });
      } else if (state === 'absolute-bottom' && this.current_state !== 'absolute-bottom') {
        this.current_state = 'absolute-bottom';
        column.css({
          'position': 'absolute',
          'top': 'auto',
          'bottom': 0
        });
      }
      if (align === 'right') {
        return column.css({
          'right': 0
        });
      }
    };

    FrameworkStickyColumn.prototype.Listeners = function() {
      var _this;
      _this = this;
      $(window).scroll(function() {
        return _this.setColumnPosition();
      });
      setInterval(function() {
        if (_this.heightsHaveChanged()) {
          _this.resetLargerColumn();
          return _this.setColumnPosition();
        }
      }, 250);
      return $(window).resize(function() {
        _this.resetLargerColumn();
        return _this.setColumnPosition();
      });
    };

    return FrameworkStickyColumn;

  })();

  LayoutAlign = (function(_super) {
    __extends(LayoutAlign, _super);

    function LayoutAlign() {}

    return LayoutAlign;

  })(FrameworkAlign);

  LayoutFooter = (function() {
    function LayoutFooter(container) {
      this.container = container;
      this.calculateWidths = __bind(this.calculateWidths, this);
    }

    LayoutFooter.prototype.calculateWidths = function() {};

    return LayoutFooter;

  })();

  LayoutHeader = (function() {
    function LayoutHeader(container) {
      this.container = container;
    }

    return LayoutHeader;

  })();

  PartialFullScreenPanel = (function() {
    function PartialFullScreenPanel(fw_media_queries) {
      this.fw_media_queries = fw_media_queries;
      this.detectAspectRatio = __bind(this.detectAspectRatio, this);
      this.listeners = __bind(this.listeners, this);
      this.nextSection = __bind(this.nextSection, this);
      this.previousSection = __bind(this.previousSection, this);
      this.removeScrollLock = __bind(this.removeScrollLock, this);
      this.scrollLock = __bind(this.scrollLock, this);
      this.getElemsToToggle = __bind(this.getElemsToToggle, this);
      this.delta = 0;
      this.scroll_threshold = 5;
      this.scroll_enabled = false;
      this.panels = $('.partial--fullscreen-panel');
      this.active_index = 0;
      this.panel_in_viewport = $('');
      this.elemsToToggle = this.getElemsToToggle();
      this.scroll_direction = 'down';
      this.detectAspectRatio();
      this.listeners();
    }

    PartialFullScreenPanel.prototype.getElemsToToggle = function() {
      if (theme.home_hide_header) {
        return $('.layout--header, .layout--footer, .owl-controls, .context-navigation');
      } else {
        return $('.layout--footer, .owl-controls, .context-navigation');
      }
    };

    PartialFullScreenPanel.prototype.scrollLock = function() {
      var _this;
      _this = this;
      if (!(theme.home_screenlocking && $('html').hasClass('no-touch') && this.panels.length > 1)) {
        return false;
      }
      $(window).on("scrollstart.PartialFullScreenPanel", function() {
        return _this.elemsToToggle.css({
          'opacity': '0'
        });
      });
      $(window).on("DOMMouseScroll.PartialFullScreenPanel mousewheel.PartialFullScreenPanel", function(event) {
        _this.panel_in_viewport.velocity("stop", true);
        if (event.originalEvent.detail < 0 || event.originalEvent.wheelDelta > 0) {
          _this.delta--;
          if (Math.abs(_this.delta) >= _this.scroll_threshold) {
            _this.scroll_direction = 'up';
            return _this.delta = 0;
          }
        } else {
          _this.delta++;
          if (_this.delta >= _this.scroll_threshold) {
            _this.scroll_direction = 'down';
            return _this.delta = 0;
          }
        }
      });
      return $(window).on("scrollstop.PartialFullScreenPanel", {
        latency: 250
      }, function() {
        var duration, fullscreen_panels, panel_in_viewport, relative_panel_offset, scroll_offset, threshold, window_height;
        window_height = $(window).height();
        fullscreen_panels = $('.partial--fullscreen-panel');
        panel_in_viewport = $('');
        relative_panel_offset = null;
        fullscreen_panels.each(function() {
          var panel_offset;
          panel_offset = $(this).offset().top - 50;
          if (window.pageYOffset < (panel_offset + window_height - 50)) {
            panel_in_viewport = $(this);
            return false;
          }
        });
        relative_panel_offset = window.pageYOffset - panel_in_viewport.offset().top;
        threshold = (window_height / 2) + panel_in_viewport.offset().top - 50;
        if (_this.scroll_direction === 'down') {
          threshold -= 100;
        } else {
          threshold += 100;
        }
        scroll_offset = -50;
        if (window.pageYOffset > threshold) {
          scroll_offset = window_height - 100;
        }
        if ((relative_panel_offset < -47 && relative_panel_offset > -53) || window_height - 100.25 === relative_panel_offset || ((panel_in_viewport.outerHeight() + 50) > window_height)) {
          _this.scroll_enabled = false;
          _this.elemsToToggle.css({
            'opacity': '1'
          });
        } else {
          duration = 400;
          panel_in_viewport.velocity("stop", true).velocity("scroll", {
            duration: duration,
            offset: scroll_offset,
            easing: 'ease'
          });
          _this.elemsToToggle.velocity("stop", true).velocity("fadeIn", {
            duration: 250,
            delay: duration
          });
        }
      });
    };

    PartialFullScreenPanel.prototype.removeScrollLock = function() {
      $(window).off("scrollstart.PartialFullScreenPanel");
      $(window).off("scrollstop.PartialFullScreenPanel");
      return $(window).off("DOMMouseScroll.PartialFullScreenPanel mousewheel.PartialFullScreenPanel");
    };

    PartialFullScreenPanel.prototype.previousSection = function() {
      var _this;
      _this = this;
      this.delta = 0;
      if (!this.animating && _this.active_index !== 0) {
        this.animating = true;
        _this.panels.eq(_this.active_index).velocity({
          translateY: ["100%", "0"]
        }, 800, "ease", function() {
          _this.animating = false;
          return $(this).css({
            visibility: 'hidden'
          });
        });
        _this.active_index--;
        _this.panels.eq(_this.active_index).css({
          visibility: 'visible'
        });
        return _this.panels.eq(_this.active_index).velocity({
          translateY: ["0", "-100%"]
        }, 800, "ease");
      }
    };

    PartialFullScreenPanel.prototype.nextSection = function() {
      var _this;
      _this = this;
      if (!this.animating && ((_this.active_index + 1) !== _this.panels.length)) {
        this.animating = true;
        _this.panels.eq(_this.active_index).velocity({
          translateY: ["-100%", "0"]
        }, 800, "ease", function() {
          _this.animating = false;
          return $(this).css({
            visibility: 'hidden'
          });
        });
        _this.active_index++;
        _this.panels.eq(_this.active_index).css({
          visibility: 'visible'
        });
        return _this.panels.eq(_this.active_index).velocity({
          translateY: ["0", "100%"]
        }, 800, "ease");
      }
    };

    PartialFullScreenPanel.prototype.listeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize', function() {
        return _this.detectAspectRatio();
      });
    };

    PartialFullScreenPanel.prototype.detectAspectRatio = function() {
      var panel_full_height, window_aspect_ratio, _this;
      _this = this;
      window_aspect_ratio = $(window).height() / $(window).width();
      panel_full_height = $(window).height() - $('.layout--header').outerHeight();
      if (window_aspect_ratio > .5 && window_aspect_ratio < .9 && _this.fw_media_queries.current_window !== 'small') {
        $('html').addClass('fullscreen');
        _this.scrollLock();
      } else {
        $('html').removeClass('fullscreen');
        _this.removeScrollLock();
      }
      return $('.partial--fullscreen-panel').each(function() {
        if (_this.fw_media_queries.current_window === 'small') {
          if ($(this).hasClass('template--index--community')) {
            return $(this).css({
              'min-height': '800px'
            });
          } else if (window_aspect_ratio > 1.5) {
            return $(this).outerHeight($(window).width() * 1.5);
          } else if ($(window).height() < 527) {
            return $(this).outerHeight(528);
          } else {
            return $(this).outerHeight(panel_full_height);
          }
        } else {
          if (window_aspect_ratio > .5 && window_aspect_ratio < .9) {
            if ($(this).index() + 1 === _this.panels.length && $('.layout--footer.negative-margin').length === 0) {
              return $(this).outerHeight(panel_full_height - 50);
            } else {
              return $(this).outerHeight(panel_full_height);
            }
          } else {
            return $(this).outerHeight(800);
          }
        }
      });
    };

    return PartialFullScreenPanel;

  })();

  PartialMainMenu = (function() {
    function PartialMainMenu(container) {
      this.container = container;
      this.markActive = __bind(this.markActive, this);
      this.slideUp = __bind(this.slideUp, this);
      this.changeTo = __bind(this.changeTo, this);
      this.slideDown = __bind(this.slideDown, this);
      this.horizontalListeners = __bind(this.horizontalListeners, this);
      this.verticalListeners = __bind(this.verticalListeners, this);
      this.subMenuLinks = __bind(this.subMenuLinks, this);
      if (this.container.hasClass('vertical')) {
        this.type = 'vertical';
      }
      if (this.container.hasClass('horizontal')) {
        this.type = 'horizontal';
      }
      this.parent_items = this.container.find('.level-1 > .item > a');
      this.sub_menu_links = this.subMenuLinks();
      this.sub_menu_items = this.sub_menu_links.parent().find('ul a');
      this.sub_menu_parents = this.sub_menu_links.parent();
      this.state = 'closed';
      this.sub_menu_panel = this.container.find('.sub_menu_panel');
      this.markActive();
      if (this.type === 'horizontal') {
        this.horizontalListeners();
      } else if (this.type === 'vertical') {
        this.verticalListeners();
      }
    }

    PartialMainMenu.prototype.subMenuLinks = function() {
      var links;
      if (this.type === 'horizontal') {
        links = this.container.find('.level-1 > .item').has('.level-2').find('> a');
        links.addClass('sub-menu-link');
        links.append('<span class="glyph--expand-more"></span><span class="glyph--expand-less"></span>');
        return links;
      } else if (this.type === 'vertical') {
        links = this.container.find('.level-1 > .item, .level-2 > .item').has('.level-2, .level-3').find('> a');
        links.addClass('sub-menu-link');
        links.append('<span class="glyph--expand-more"></span><span class="glyph--expand-less"></span>');
        return links;
      }
    };

    PartialMainMenu.prototype.verticalListeners = function() {
      var this_class;
      this_class = this;
      return this.sub_menu_links.on('click.PartialMainMenu', function() {
        if ($(this).hasClass('open')) {
          this_class.slideUp($(this));
        } else {
          this_class.slideDown($(this));
        }
        return false;
      });
    };

    PartialMainMenu.prototype.horizontalListeners = function() {
      var _this;
      _this = this;
      this.sub_menu_parents.on('mouseenter.PartialMainMenu touchstart.PartialMainMenu', function(e) {
        if (!$(this).hasClass('open')) {
          e.preventDefault();
        }
        return _this.slideDown($(this));
      });
      this.sub_menu_parents.on('mouseleave.PartialMainMenu', function() {
        return _this.slideUp($(this));
      });
      this.parent_items.on('focus', function(e) {
        _this.container.find('.level-2').hide();
        _this.container.find('.glyph--expand-less').hide();
        return _this.container.find('.glyph--expand-more').show();
      });
      this.sub_menu_links.on('focus', function(e) {
        console.log('sub menu focus');
        _this.slideDown($(this));
        $(this).closest('.item').find('.glyph--expand-less').show();
        return $(this).closest('.item').find('.glyph--expand-more').hide();
      });
      return this.sub_menu_items.on('touchstart', function(e) {
        return e.stopImmediatePropagation();
      });
    };

    PartialMainMenu.prototype.slideDown = function(link) {
      var sub_menu, this_class;
      this_class = this;
      if (this.type === 'horizontal') {
        this.state = 'open';
        link.addClass('open');
        sub_menu = link.closest('.item').find('.list.level-2');
        return sub_menu.stop(true, true).slideDown(200, function() {
          return {
            'easing': 'easeOutExpo'
          };
        });
      } else if (this.type === 'vertical') {
        link.addClass('open');
        if (link.closest('.list').hasClass('level-1')) {
          sub_menu = link.closest('.item').find('.list.level-2');
        } else if (link.closest('.list').hasClass('level-2')) {
          sub_menu = link.closest('.item').find('.list.level-3');
        }
        return sub_menu.show();
      }
    };

    PartialMainMenu.prototype.changeTo = function(link) {
      var sub_menu, this_class;
      this_class = this;
      sub_menu = this.sub_menu_panel.find('.list.level-2');
      sub_menu.animate({
        opacity: 0
      }, 200);
      this.sub_menu_panel.empty();
      this.container.find('.list > .item > .open').removeClass('open');
      return this.slideDown(link);
    };

    PartialMainMenu.prototype.slideUp = function(link) {
      var sub_menu, this_class;
      this_class = this;
      if (this.type === 'horizontal') {
        link.removeClass('open');
        this.state = 'closed';
        sub_menu = link.parent().find('.list.level-2');
        return sub_menu.fadeOut(200, function() {
          return {
            'easing': 'easeOutExpo'
          };
        });
      } else if (this.type === 'vertical') {
        link.removeClass('open');
        sub_menu = link.closest('.item').find('.list.level-2');
        if (link.closest('.list').hasClass('level-1')) {
          sub_menu = link.closest('.item').find('.list.level-2');
        } else if (link.closest('.list').hasClass('level-2')) {
          sub_menu = link.closest('.item').find('.list.level-3');
        }
        return sub_menu.hide();
      }
    };

    PartialMainMenu.prototype.markActive = function() {
      var this_class, url;
      this_class = this;
      url = window.location.href;
      return this.container.find('a').filter(function() {
        return this.href === url;
      }).addClass('active');
    };

    return PartialMainMenu;

  })();

  PartialProduct = (function() {
    function PartialProduct(container, cart_modal, fw_media_queries) {
      this.container = container;
      this.cart_modal = cart_modal;
      this.fw_media_queries = fw_media_queries;
      this.resizeListeners = __bind(this.resizeListeners, this);
      this.copyLink = __bind(this.copyLink, this);
      this.fillYSpace = __bind(this.fillYSpace, this);
      this.resizePanels = __bind(this.resizePanels, this);
      this.balanceColumns = __bind(this.balanceColumns, this);
      this.indexContentBlocks = __bind(this.indexContentBlocks, this);
      this.initiateVariants = __bind(this.initiateVariants, this);
      this.variantSelected = __bind(this.variantSelected, this);
      this.updateVariantImage = __bind(this.updateVariantImage, this);
      this.addProductComplete = __bind(this.addProductComplete, this);
      this.renderCart = __bind(this.renderCart, this);
      this.addToCartListener = __bind(this.addToCartListener, this);
      this.quantityListeners = __bind(this.quantityListeners, this);
      this.form = this.container.find('form.add-to-cart');
      this.add_button = this.container.find('button.add');
      this.compare_price = this.container.find('.compare-price');
      this.actual_price = this.container.find('.actual-price');
      this.product_unavailable = this.container.find('.product-unavailable');
      this.quantity = this.container.find('.quantity');
      this.handle = this.container.data('handle');
      this.id = this.container.data('id');
      this.view = this.container.data('view');
      this.initiateVariants();
      this.quantityListeners();
      if (theme.cart_type === 'modal') {
        this.addToCartListener();
      }
      this.indexContentBlocks();
      this.copyLink();
      this.resizeListeners();
    }

    PartialProduct.prototype.quantityListeners = function() {
      var _this;
      _this = this;
      _this.quantity.find('.plus').on('click.PartialProduct', function() {
        var input;
        input = _this.quantity.find('input');
        return input.val(1 + parseInt(input.val()));
      });
      return _this.quantity.find('.minus').on('click.PartialProduct', function() {
        var input;
        input = _this.quantity.find('input');
        if (parseInt(input.val()) > 1) {
          return input.val(parseInt(input.val()) - 1);
        }
      });
    };

    PartialProduct.prototype.addToCartListener = function() {
      var _this;
      _this = this;
      if (this.form.length > 0) {
        return this.form.submit(function() {
          _this.form.find('p.error').remove();
          _this.add_button.addClass('loading');
          _this.cart_modal.addItem($(this), function(pass, error) {
            if (pass) {
              return _this.renderCart();
            } else {
              _this.form.append('<p class="error">' + error + '</p>');
              return _this.add_button.removeClass('loading');
            }
          });
          return false;
        });
      }
    };

    PartialProduct.prototype.renderCart = function() {
      var _this;
      _this = this;
      return _this.cart_modal.renderCart(function() {
        return _this.addProductComplete();
      });
    };

    PartialProduct.prototype.addProductComplete = function() {
      var _this;
      _this = this;
      _this.add_button.removeClass('loading');
      return $('.fw--modal.cart-link .modal-link').trigger('click');
    };

    PartialProduct.prototype.updateVariantImage = function(variant_id) {
      var featured_image, featured_image_wrapper, first_modal, modal_images, new_varaint_image, other_image_wrapper, other_image_wrappers, other_images, _this;
      _this = this;
      featured_image_wrapper = $('.product .featured-image .image-wrapper');
      other_image_wrappers = $('.product .content .image-wrapper');
      featured_image = featured_image_wrapper.find('img');
      other_images = $('.product .content .image-wrapper img');
      modal_images = $('.product .featured-image .modal img');
      if (featured_image.data('image-id') !== variant_id) {
        new_varaint_image = other_images.filter('[data-image-id="' + variant_id + '"]');
        other_image_wrapper = new_varaint_image.parent();
        new_varaint_image.appendTo(featured_image_wrapper);
        featured_image.removeClass('fw--align--center-y').appendTo(other_image_wrapper);
        first_modal = modal_images.filter('[data-image-id="' + variant_id + '"]').parent();
        first_modal.prependTo($('.product .featured-image'));
        $('.product .featured-image .image-wrapper img').addClass('fw--align--center-y');
        _this.balanceColumns();
      }
    };

    PartialProduct.prototype.variantSelected = function(variant, selector, options) {
      var product, product_title, product_variant_size, _this;
      _this = this;
      product = $('#' + selector.domIdPrefix).closest('.partial--product');
      product_variant_size = product.data('variants-size');
      product_title = product.closest('.product').find('.details .title').html();
      _this.compare_price.html("");
      if (variant && variant.available) {
        _this.quantity.show();
        _this.add_button.show();
        _this.product_unavailable.hide();
      } else {
        _this.quantity.hide();
        _this.add_button.hide();
        _this.product_unavailable.show();
        if (product_variant_size > 1 && variant) {
          _this.product_unavailable.find('form .email-body').attr('value', theme.translation.products_sold_out_email_description + ": " + product_title + ' - ' + variant.title);
        }
      }
      if (variant) {
        _this.actual_price.html(Shopify.formatMoney(variant.price, theme.money_format));
        if (variant.compare_at_price > variant.price) {
          _this.compare_price.html(Shopify.formatMoney(variant.compare_at_price, theme.money_format));
        }
        if (theme.currency_switcher_enabled) {
          Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, _this.actual_price, null, true);
          Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, _this.compare_price, null, true);
        }
        if (_this.view === 'product-page') {
          if (variant.featured_image) {
            _this.updateVariantImage(variant.featured_image.id);
          } else {
            _this.updateVariantImage(0);
          }
        }
      }
    };

    PartialProduct.prototype.initiateVariants = function(json) {
      var duplicate_exists, history_state, variant_id, _this;
      _this = this;
      if (!$('.template--product').length) {
        variant_id = "product-select-" + _this.id;
        duplicate_exists = false;
        if ($.inArray(variant_id, theme.variant_id_list) === -1) {
          theme.variant_id_list.push(variant_id);
        } else {
          duplicate_exists = true;
          $("#" + variant_id).first().attr("id", variant_id + "--disabled");
        }
        history_state = false;
        if (_this.view === 'product-page') {
          history_state = true;
        }
        if (_this.container.find('select').length > 0) {
          new Shopify.OptionSelectors(variant_id, {
            product: theme.product_json[_this.id],
            onVariantSelected: _this.variantSelected,
            enableHistoryState: history_state
          });
        }
        if (duplicate_exists) {
          return $("#" + variant_id + "--disabled").first().attr("id", variant_id);
        }
      }
    };

    PartialProduct.prototype.indexContentBlocks = function() {
      var content_blocks;
      content_blocks = $('.layout--main-content .product .content .block');
      return content_blocks.each(function(index) {
        return $(this).attr('data-block-index', index);
      });
    };

    PartialProduct.prototype.balanceColumns = function() {
      var images, _this;
      _this = this;
      if ($("html.lt-ie9").length > 0) {
        return false;
      }
      images = $('.layout--main-content .product .content img');
      return images.imagesLoaded(function() {
        var content, content_blocks, image_count, left_side, right_side, single_column;
        content = $('.layout--main-content .product .content');
        single_column = content.find('.single-column');
        content_blocks = content.find('.block');
        left_side = content.find('.left-side');
        right_side = content.find('.right-side');
        image_count = content.find('img').length;
        content_blocks.sort(function(a, b) {
          return +a.getAttribute('data-block-index') - +b.getAttribute('data-block-index');
        }).appendTo(single_column);
        single_column.show();
        left_side.hide();
        right_side.hide();
        if (image_count > 1 && _this.fw_media_queries.current_window !== 'small') {
          content_blocks.each(function(index) {
            var left_height, right_height;
            left_height = left_side.outerHeight();
            right_height = right_side.outerHeight();
            if (left_height <= right_height) {
              return $(this).appendTo(left_side);
            } else {
              return $(this).appendTo(right_side);
            }
          });
          single_column.hide();
          left_side.show();
          return right_side.show();
        }
      });
    };

    PartialProduct.prototype.resizePanels = function() {
      var _this;
      _this = this;
      return $('.partial--fullscreen-panel').each(function() {
        var panel_full_height, window_aspect_ratio;
        window_aspect_ratio = $(window).height() / $(window).width();
        panel_full_height = $(window).height() - $('.layout--header').outerHeight();
        if ($(this).hasClass('featured-image')) {
          if (_this.fw_media_queries.current_window !== 'small') {
            panel_full_height -= $('.add-to-cart-panel').outerHeight() + 50;
          }
        }
        if ($(this).hasClass('collection')) {
          if (_this.fw_media_queries.current_window !== 'small') {
            panel_full_height -= $('.related-collection .header').outerHeight() + 50;
          }
        }
        if (_this.fw_media_queries.current_window === 'small') {
          if (window_aspect_ratio > 1.5) {
            return $(this).outerHeight($(window).width() * 1.5);
          } else {
            return $(this).outerHeight(panel_full_height);
          }
        } else {
          if (window_aspect_ratio > .5 && window_aspect_ratio < .9) {
            return $(this).outerHeight(panel_full_height);
          } else {
            return $(this).outerHeight(800);
          }
        }
      });
    };

    PartialProduct.prototype.fillYSpace = function() {
      return $('.related-collection .slide').each(function() {
        var container_height, img, max_height, text_panel_height;
        container_height = $(this).height();
        text_panel_height = $(this).find('.text-panel').outerHeight();
        img = $(this).find('img');
        max_height = container_height - text_panel_height - parseInt(img.css('padding-top')) - parseInt(img.css('padding-bottom'));
        return img.css({
          'max-height': max_height
        });
      });
    };

    PartialProduct.prototype.copyLink = function() {
      var copy_link, copy_link_textarea;
      copy_link = $('.partial--social-media .copy-link a');
      copy_link_textarea = copy_link.parent().find('textarea');
      copy_link.on('click', function() {
        copy_link_textarea.toggle();
        copy_link_textarea.focus();
        return false;
      });
      return copy_link.parent().find('textarea').on('focus', function() {
        var $this;
        $this = $(this);
        $this.select();
        return $this.on('mouseup', function() {
          $this.unbind("mouseup");
          return false;
        });
      });
    };

    PartialProduct.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      _this.resizePanels();
      _this.fillYSpace();
      _this.balanceColumns();
      return $(window).on('resize.TemplateProduct', function() {
        _this.resizePanels();
        _this.fillYSpace();
        return _this.balanceColumns();
      });
    };

    return PartialProduct;

  })();

  jQuery(function($) {
    var MAIN, PAGE, copyLink, digitalDownloads, framework_cart_modal, fw_loading_animation, fw_media_queries, isFirefox, stickyFooter, templateArticle, templateCollection, templateIndex;
    PAGE = $('body');
    MAIN = $('.layout--main-content');
    theme.money_format = Currency.moneyFormats[theme.shop_currency].money_format;
    $('.fw--cart-modal--trigger-render span.total-price').addClass('money');
    $('.template--product .partial--product.view--full .actual-price').addClass('money');
    fw_loading_animation = new FrameworkLoadingAnimation();
    fw_media_queries = new FrameworkMediaQueries();
    $('a[href^="http"]').not('a[href^="' + theme.shop_url + '"]').attr('target', '_blank');
    $('input, textarea').placeholder();
    isFirefox = typeof InstallTrigger !== "undefined";
    if (isFirefox) {
      $('img').addClass('image-scale-hack');
    }
    new FrameworkAnimation();
    new FrameworkOffCanvas();
    $('.fw--search').each(function() {
      return new FrameworkSearch($(this));
    });
    $('.fw--modal').each(function() {  
      return new FrameworkModal($(this));
    });
   
    framework_cart_modal = new FrameworkCart($('.fw--cart.modal'), fw_media_queries);
    $('.fw--slider').each(function() {
      return new FrameworkSlider($(this));
    });
    $('.fw--align--left').each(function() {
      return new FrameworkAlign($(this), 'left');
    });
    $('.fw--align--center-x').each(function() {
      return new FrameworkAlign($(this), 'center-x');
    });
    $('.fw--align--right').each(function() {
      return new FrameworkAlign($(this), 'right');
    });
    $('.fw--align--top').each(function() {
      return new FrameworkAlign($(this), 'top');
    });
    $('.fw--align--center-y').each(function() {
      return new FrameworkAlign($(this), 'center-y');
    });
    $('.fw--align--bottom').each(function() {
      return new FrameworkAlign($(this), 'bottom');
    });
    if ($('.layout--header').length > 0) {
      new LayoutHeader($('.layout--header'));
    }
    if ($('.layout--footer').length > 0) {
      new LayoutFooter($('.layout--footer'));
    }
    $('.partial--main-menu').each(function() {
      return new PartialMainMenu($(this));
    });
    $('.partial--mailing-list').each(function() {
      return $(this).find('input[type="email"]').focus(function() {
        return $(this).parent().find('.button').fadeIn();
      });
    });
    if (PAGE.hasClass('template--index')) {
      new PartialFullScreenPanel(fw_media_queries);
      templateIndex = function() {
        var communityPanel, fillYSpace, newsPanel, resizePanels;
        resizePanels = function() {
          var panel_full_height, window_aspect_ratio;
          window_aspect_ratio = $(window).height() / $(window).width();
          panel_full_height = $(window).height() - $('.layout--header').outerHeight();
          return setTimeout(function() {
            $('.fw--ellipsis iframe').remove();
            return $('.fw--ellipsis').dotdotdot();
          }, 250);
        };
        resizePanels();
        fillYSpace = function() {
          $('.template--index--custom-content .container').each(function() {
            var container_height, text_panel_height;
            if ($(this).hasClass('panel-align--top') || $(this).hasClass('panel-align--bottom')) {
              container_height = $(this).height();
              text_panel_height = $(this).find('.text-panel').outerHeight();
              return $(this).find('.image-panel').height(container_height - text_panel_height);
            }
          });
          return $('.template--index--collection .slide').each(function() {
            var container_height, img, max_height, text_panel_height;
            container_height = $(this).height();
            text_panel_height = $(this).find('.text-panel').outerHeight();
            img = $(this).find('img');
            max_height = container_height - text_panel_height - parseInt(img.css('padding-top')) - parseInt(img.css('padding-bottom'));
            return img.css({
              'max-height': max_height
            });
          });
        };
        fillYSpace();
        newsPanel = function() {
          var containers, panel, setMaxImageHeight, slides;
          panel = $('.template--index--news');
          slides = panel.find('.slide');
          containers = slides.find('.container');
          slides.imagesLoaded(function() {
            var images;
            images = panel.find('img');
            return slides.each(function() {
              var column_b, column_c, container, image, layout_type, link, ratio, slide, title;
              slide = $(this);
              container = slide.find('.container.show--medium-large');
              image = container.find('img');
              if (image.length) {
                ratio = image.outerWidth() / image.outerHeight();
              } else {
                ratio = 0;
              }
              layout_type = null;
              container.removeClass('layout-type--a');
              if (ratio === 0) {
                layout_type = 'b';
              } else if (ratio < 0.76) {
                layout_type = 'a';
              } else if (ratio > 1.24) {
                layout_type = 'b';
              } else {
                layout_type = 'c';
              }
              layout_type = 'layout-type--' + layout_type;
              container.addClass(layout_type);
              if (layout_type === 'layout-type--c') {
                column_b = container.find('.column-b');
                column_c = container.find('.column-c');
                title = container.find('.title');
                link = container.find('.more-details');
                column_c.prepend(title);
                column_b.append(link);
              }
              return setMaxImageHeight();
            });
          });
          setMaxImageHeight = function() {
            return containers.each(function() {
              var column_a, column_c, container, image, image_wrapper, max_height, slide;
              container = $(this);
              slide = container.closest('.slide');
              image = container.find('img');
              image_wrapper = image.parent();
              column_a = container.find('.column-a');
              column_c = container.find('.column-c');
              if (container.hasClass('layout-type--a')) {
                max_height = slide.height() - parseInt(image_wrapper.css('padding-top')) - parseInt(image_wrapper.css('padding-bottom'));
                return image.css({
                  'max-height': max_height
                });
              } else if (container.hasClass('layout-type--b')) {
                max_height = slide.height() - parseInt(image_wrapper.css('padding-top')) - parseInt(image_wrapper.css('padding-bottom')) - column_a.outerHeight() - column_c.outerHeight();
                return image.css({
                  'max-height': max_height
                });
              }
            });
          };
          return $(window).on('resize.newsPanel', function() {
            return setMaxImageHeight();
          });
        };
        newsPanel();
        communityPanel = function() {
          if ($('.template--index--community .partial--social-media h3').length < 1) {
            return $('.template--index--community .partial--mailing-list').css({
              'float': 'none',
              'text-align': 'center'
            });
          }
        };
        communityPanel();
        return $(window).on('resize.TemplateIndex', function() {
          resizePanels();
          return fillYSpace();
        });
      };
      templateIndex();
    }
    if (PAGE.hasClass('template--collection')) {
      templateCollection = function() {
        var matchImageHeights, positionHeaderText, truncateDescription;
        positionHeaderText = function() {
          return MAIN.find('header .text').css({
            'margin-top': -(MAIN.find('.text').outerHeight() / 2)
          });
        };
        positionHeaderText();
        truncateDescription = function() {
          $('.featured-product .description iframe').remove();
          return $('.featured-product .description').dotdotdot();
        };
        truncateDescription();
        matchImageHeights = function() {
          var greatest_height, product_grid;
          product_grid = $('.product-grid');
          greatest_height = 0;
          if (fw_media_queries.current_window === 'small') {
            product_grid.find('.image-wrapper').attr('style', '');
            product_grid.find('img').removeClass('fw--align--center-y');
            return false;
          }
          if (product_grid.hasClass('clear-after--medium-3') || product_grid.hasClass('clear-after--medium-2')) {
            return product_grid.imagesLoaded(function() {
              product_grid.find('.partial--product.view--grid').each(function() {
                if ($(this).find('img').height() > greatest_height) {
                  return greatest_height = $(this).find('img').height();
                }
              });
              return product_grid.find('.partial--product.view--grid').each(function() {
                if ($(this).find('img').height() < greatest_height) {
                  $(this).find('.image-wrapper').css('height', greatest_height);
                  return $(this).find('img').addClass('fw--align--center-y');
                }
              });
            });
          }
        };
        matchImageHeights();
        return $(window).on('resize.TemplateCollection', function() {
          positionHeaderText();
          truncateDescription();
          return matchImageHeights();
        });
      };
      templateCollection();
    }
    if (PAGE.hasClass('template--product')) {
      theme.product = new PartialProduct($('.partial--product.view--full'), framework_cart_modal, fw_media_queries);
    }
    if (PAGE.hasClass('template--article')) {
      templateArticle = function() {
        var first_article_img, pinterest_button;
        pinterest_button = $('.share-buttons .glyph--pinterest');
        first_article_img = $('article img').first().attr('src');
        return pinterest_button.attr('href', pinterest_button.attr('href') + '&media=' + first_article_img);
      };
      templateArticle();
      copyLink = function() {
        var copy_link, copy_link_textarea;
        copy_link = $('.partial--social-media .copy-link a');
        copy_link_textarea = copy_link.parent().find('textarea');
        copy_link.on('click', function() {
          copy_link_textarea.toggle();
          copy_link_textarea.focus();
          return false;
        });
        return copy_link.parent().find('textarea').on('focus', function() {
          var $this;
          $this = $(this);
          $this.select();
          return $this.on('mouseup', function() {
            $this.unbind("mouseup");
            return false;
          });
        });
      };
      copyLink();
    }
    digitalDownloads = function() {
      if ($('.sdd-download').length) {
        return $('.sdd-download-button').removeClass('sdd-download-button').css('visibility', 'visible');
      }
    };
    digitalDownloads();
    $('.fw--align--fill-y').each(function() {
      return new FrameworkAlign($(this), 'fill-y');
    });
    $('.fw--align--max-img-height').each(function() {
      return new FrameworkAlign($(this), 'max-img-height');
    });
    $('html').addClass('after-js-loaded');
    $(document).on("ie8ClearingFix", function() {
      if ($('html').hasClass('lt-ie9')) {
        return $('.fw--blocks[data-ie8-clear-after]').each(function() {
          var clear_after;
          $(this).find('.ie8-clearer').remove();
          clear_after = $(this).data('ie8-clear-after');
          return $(this).children().each(function(i) {
            if ((i + 1) % clear_after === 0) {
              return $('<div class="ie8-clearer"></div>').insertAfter($(this));
            }
          });
        });
      }
    });
    $.event.trigger("ie8ClearingFix");
    stickyFooter = function() {
      if ($(window).outerHeight() > $('.fw--off-canvas--main-content').outerHeight()) {
        return $('.layout--main-content').css({
          'min-height': $(window).outerHeight() - $('.layout--footer').outerHeight()
        });
      }
    };
    stickyFooter();
    $(window).resize(function() {
      return stickyFooter();
    });
    return setTimeout(function() {
      return $(".owl-carousel").each(function() {
        return $(this).data('owlCarousel').calculateAll();
      });
    }, 0);
  });

}).call(this);

$('.minimized-link').on('click', function() {
 
    $(".blockfancy").css("visibility","visible");
    $(".blockfancy").css("opacity","0.85"); 
  
    $(".fw--off-canvas--viewport").css("transform","translateX(-250px)");  
    $(".drawer").css("transform","translateX(-250px)");

    $("html").css("overflow-y","hidden"); 
    $(".blockfancy").css("z-index","1000");
    
  
});

function retornareventofancy(){
    $(".blockfancy").css("visibility","hidden")
    $(".blockfancy").css("opacity","0");
  
    $(".fw--off-canvas--viewport").css("transform","none");
    $(".drawer").css("transform","none"); 
  
    $("html").css("overflow-y","visible"); 
    $(".blockfancy").css("z-index","-1000");  
}


    $(".blockfancy").click(function(){
        retornareventofancy();  
    })

    $(".drawer__close").click(function(){
        retornareventofancy();  
    })

/** move email form**/


  /*var mediaquery = window.matchMedia("(min-width: 1120px)");

  if (mediaquery.matches){
         $( "#email-input_desk" ).focus(function(){
         $("#email-input_desk").css("transform","translateX(-100px)");
         $("#font--subheading-1").css("transform","translateX(-100px)");
      });
  } */

    $("#email-input_desk" ).focus(function(){
          $("#email-input_desk").css("transform","translateX(-100px)");
          $("#font--subheading-1").css("transform","translateX(-100px)");
    });

    $(".email-input_foo" ).focus(function(){
        $(this).attr("placeholder","");
    });

    $(".email-input_foo" ).blur(function() {
        $(this).attr("placeholder","Email Address");
    });

    $("#email-input_desk").keyup(function(){
        $("#email-input_mob").val(this.value);
    });

    $("#email-input_mob").keyup(function(){
        $("#email-input_desk").val(this.value);
    });


      
/** This will disable hover state on mobile devices **/
function watchForHover() {
    var hasHoverClass = false;
    var container = document.body;
    var lastTouchTime = 0;

    function enableHover() {
        // filter emulated events coming from touch events
        if (new Date() - lastTouchTime < 500) return;
        if (hasHoverClass) return;

        container.className += ' hasHover';
        hasHoverClass = true;
    }

    function disableHover() {
        if (!hasHoverClass) return;

        container.className = container.className.replace(' hasHover', '');
        hasHoverClass = false;
    }

    function updateLastTouchTime() {
        lastTouchTime = new Date();
    }

    document.addEventListener('touchstart', updateLastTouchTime, true);
    document.addEventListener('touchstart', disableHover, true);
    document.addEventListener('mousemove', enableHover, true);

    enableHover();
}

watchForHover();
